import angular, { IHttpPromiseCallbackArg, IQService } from 'angular';
import RunnerFlowService from './runner.flow.service';
import IFormattedFlow from '../../interfaces/IFormattedFlow';
import { IStateParamsService, IStateProvider } from 'angular-ui-router';
import { SharedAngular } from '@Client/@types/sharedAngular';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

///
/// This state displays flows that the user can initiaite
///

// Register the application's routes configuration.
angular.module('flowingly.runner.flow').config(config);

// Inject the dependencies.
config.$inject = ['$stateProvider'];

function config($stateProvider: IStateProvider) {
  $stateProvider.state(STATE_MAPPINGS.flow, {
    url: 'flows/{flowId}?showComments&flowModelId&stepTask&isTestFlow',
    params: { title: 'Flow Details', searchJump: false },
    controller: 'runnerFlowController',
    controllerAs: '$ctrl',
    templateUrl: 'Client/runner.flow/runner.flow/runner.flow.tmpl.html',
    resolve: {
      flow: [
        '$stateParams',
        '$q',
        'flowModelApiService',
        'sessionService',
        'runnerFlowService',
        'guidService',
        function (
          $stateParams: IStateParamsService,
          $q: IQService,
          flowModelApiService: SharedAngular.FlowModelApiService,
          sessionService: SharedAngular.SessionService,
          runnerFlowService: RunnerFlowService,
          guidService: SharedAngular.GuidService
        ) {
          const flowId = $stateParams.flowId;
          if (flowId == guidService.empty()) {
            const flowModelId = $stateParams.flowModelId;

            return $q
              .all([
                flowModelApiService.getFlowModelById(flowModelId),
                sessionService.getUser()
              ])
              .then(([flowModel, currentUser]) => {
                const placeholder =
                  flowModel.customPlaceholder != null &&
                  flowModel.customPlaceholder != ''
                    ? flowModel.customPlaceholder
                    : 'Enter a descriptive subject';
                return <IFormattedFlow>{
                  flowModelId: flowModelId,
                  flowId: guidService.empty(),
                  flowIdentifier: 'FLOW-',
                  momentDue: '',
                  subject: '...',
                  currentStepsHeader: 'Enter Subject',
                  name: flowModel.name,
                  startedByName: currentUser.fullName,
                  percentageComplete: 0,
                  waitingForName: currentUser.fullName,
                  customPlaceholder: placeholder,
                  id: null,
                  category: null,
                  categoryId: null,
                  flowSchema: null,
                  parsedSchema: null,
                  startedByUserId: null,
                  startedDate: null,
                  finalisedDate: null,
                  finalisedReason: null,
                  isStartedByYou: null,
                  isFlowModelOwner: null,
                  commentCount: null,
                  isWaitingForYou: null,
                  numberOfCompletedSteps: null,
                  numberOfNotCompletedSteps: null,
                  steps: null,
                  waitingForDate: null,
                  bulkStartId: null,
                  ccUsers: null,
                  isFlowModelPublishedToUser: null,
                  flowComponentSchemas: null,
                  isObsolete: null,
                  flowVersionNumber: null,
                  requestedByUserId: null,
                  requestedByUser: null,
                  latestSchemaVersion: null,
                  description: null,
                  isFinalised: null,
                  finalisedInLocalFormat: null,
                  dueDateInLocalFormat: null,
                  momentStartedFullDate: null,
                  momentStarted: null,
                  whoStarted: null,
                  momentFinalised: null,
                  momentFinalisedFullDate: null,
                  momentFinalisedInLocalFormat: null,
                  momentWaitingFor: null,
                  momentWaitingForLabel: null,
                  isDeleted: null,
                  isOverdue: null,
                  filesCount: null,
                  timeZone: null,
                  tagIds: []
                };
              })
              .catch((response) => {
                return response.status === 403
                  ? 'permission denied'
                  : response.statusText;
              });
          } else {
            return runnerFlowService
              .getFlowById(flowId)
              .catch((response: IHttpPromiseCallbackArg<null>) => {
                $stateParams.flowRequestErrorStatus = response.status;
              });
          }
        }
      ]
    }
  });
}
